import { useEffect } from "react";
import { NotifyCenter } from "project-config/services/notify-center";
import { useTranslation } from "react-i18next";
import { CreateInterceptModal } from "task-eva-ui";
import request from "project-config/services/request/request";
import { useToastStore } from "@/store/toast-store";

export function useResponseInterceptor() {
  const { t } = useTranslation("common");
  const { t: errorT } = useTranslation("error");
  const { showGlobalToast } = useToastStore();
  useEffect(() => {
    const axiosResponseInterceptorSubscriber =
      NotifyCenter.axiosResponseInterceptor.subscribe((response) => {
        const {
          data: { code, message },
          config: { url },
        } = response;
        if (whiteListCode.includes(code)) return;
        if (whiteListURL.includes(url || "")) return;
        if ([404, 502].includes(response.status)) {
          showGlobalToast({
            type: "error",
            content: t("error_network"),
          });
          return;
        }
        if (code === 840) {
          const handle = async () => {
            await request.post("/api/rendering/user/deleteSubUserKey");
          };
          CreateInterceptModal.handle = handle;
          CreateInterceptModal.emit({
            type: "sub-account-modify-password",
            title: t("common_tip"),
            content: t("common_sub_account_modify_password"),
          });
          return;
        }
        // 因为/api/sso/userInfo/getInfo接口返回的code是string，所以需要进行类型转换
        if (
          !(code === 200 || (code as unknown as string) === "Common.Success") &&
          message
        ) {
          showGlobalToast({
            type: "error",
            content: errorT(message),
          });
        }
      });
    return () => {
      axiosResponseInterceptorSubscriber.unsubscribe();
    };
  });
}

export const whiteListCode = [714, 715, 735, 736, 713, 734, 612, 631];
export const whiteListURL = ["/api/rendering/user/validate/userName"];
